import React, { useEffect, useState } from 'react';
import { AppState } from '$/store';
import { connect } from 'react-redux';
import * as Bixby from '$/core';
import './index.scss';
import { createDataSiteHost, getDataSiteHosts } from '$/store/settings/actions';
import Loading from '$/components/loading/Loading';
import InputBlock from '$/components/global/inputBlock';
import BixButton from '$/components/global/bixButton';
import Modal from '$/components/global/modal';

interface IDataSiteHosts {
  isLoading: boolean;
  error?: Bixby.Models.BixbyError;
  dispatchGetDataSiteHosts: () => Bixby.Models.DataSiteHost[];
  dataSiteHosts?: Bixby.Models.DataSiteHost[];
  dispatchCreateDataSiteHost: (request: Bixby.Models.DataSiteHostRequest) => Bixby.Models.DataSiteHost[];
}

const DataSiteHostSettings: React.FC<IDataSiteHosts> = props => {
  const { isLoading, dispatchGetDataSiteHosts, dataSiteHosts, dispatchCreateDataSiteHost } = props;
  const [orderDataSiteHosts, setOrderedDataSiteHosts] = useState(dataSiteHosts as Bixby.Models.DataSiteHost[]);
  const [dataSiteHostToAdd, setDataStieHostToAdd] = useState(undefined as string | undefined);
  const [addDataSiteHostModalActive, setAddDataSiteHostModalActive] = useState(false);

  useEffect(() => {
    const getDataSiteHosts = async () => {
      await dispatchGetDataSiteHosts();
    };
    getDataSiteHosts();
  }, [dispatchGetDataSiteHosts]);

  useEffect(() => {
    const ordered: Bixby.Models.DataSiteHost[] = Bixby.Utils.orderBy(dataSiteHosts, c => c.name);
    setOrderedDataSiteHosts(ordered);
  }, [dataSiteHosts]);

  const handleSetDataSiteHostName = (ev: React.FormEvent<HTMLInputElement>) => {
    const toAdd = ev.currentTarget.value;
    setDataStieHostToAdd(toAdd);
  };

  const handleOpenConfirmAddDataSiteHost = () => {
    setAddDataSiteHostModalActive(true);
  };

  const handleAddDataSiteHost = async () => {
    if (dataSiteHostToAdd) {
      const request = {
        name: dataSiteHostToAdd,
      } as Bixby.Models.DataSiteHostRequest;
      await dispatchCreateDataSiteHost(request);
    }
    setAddDataSiteHostModalActive(false);
  };

  const handleCancelAddDataSiteHost = () => {
    setAddDataSiteHostModalActive(false);
  };

  if (isLoading) {
    return <Loading pageLevel />;
  } else {
    return dataSiteHosts && !Bixby.Utils.isNullOrEmpty(dataSiteHosts) ? (
      <React.Fragment>
        <section className="dataSiteHost_list">
          <div>
            <h2>Active Data Site Hosts</h2>
            <ul>
              {orderDataSiteHosts?.map((dsh: Bixby.Models.DataSiteHost) => (
                <li key={dsh.id}>{dsh.name}</li>
              ))}
            </ul>
          </div>
          <div>
            <h2>Create a Data Site Host</h2>
            <InputBlock title="Name">
              <input name="createDataSiteHost" onChange={handleSetDataSiteHostName} />
            </InputBlock>
            <BixButton
              type="button"
              disabled={Bixby.Utils.isNullOrEmpty(dataSiteHostToAdd)}
              onClick={handleOpenConfirmAddDataSiteHost}
              isLoading={isLoading}>
              Create
            </BixButton>
          </div>
          <Modal
            title="Confirm Data Site Host"
            active={addDataSiteHostModalActive}
            onClose={handleCancelAddDataSiteHost}>
            <p>Create Data Site Host {dataSiteHostToAdd}?</p>
            <div className="button_side_wrap">
              <BixButton type="button" onClick={handleAddDataSiteHost}>
                Add {(dataSiteHostToAdd || ({} as any)).name}
              </BixButton>
              <BixButton light type="button" onClick={handleCancelAddDataSiteHost}>
                Cancel
              </BixButton>
            </div>
          </Modal>
        </section>
      </React.Fragment>
    ) : (
      <p>No Data Site Hosts Found.</p>
    );
  }
};

const mapStateToProps = (state: AppState) => {
  return {
    isLoading: state.settingsState.isLoading,
    error: state.settingsState.error,
    dataSiteHosts: state.settingsState.dataSiteHosts,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetDataSiteHosts: () => dispatch(getDataSiteHosts()),
  dispatchCreateDataSiteHost: (request: Bixby.Models.DataSiteHostRequest) => dispatch(createDataSiteHost(request)),
});
export default connect(mapStateToProps, mapDispatchToProps)(DataSiteHostSettings);
